"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBPART_L_NOT_ADOPTED = void 0;
exports.getEpisodicRelief = getEpisodicRelief;
exports.episodicEventsApplicableForState = episodicEventsApplicableForState;
const states_1 = require("encamp-shared/dist/constants/states");
const facilityState_1 = require("../facilityState");
const jurisdictions_1 = require("../rules/jurisdictions");
/** Raw `Facility.state`; null answers federally, junk throws. */
function getEpisodicRelief(facilityState) {
    const state = (0, facilityState_1.parseFacilityState)(facilityState);
    if (state === null || (0, jurisdictions_1.jurisdictionRulesFor)(state).adoptsEpisodicEvents) {
        return { isAvailable: true };
    }
    const stateName = states_1.stateNamesByAbbreviation.get(state) ?? state;
    return {
        isAvailable: false,
        reason: `${stateName} hasn't adopted the episodic event provision (40 CFR 262 subpart L), ` +
            "so the event will be recorded, but generator status and deadlines won't change",
    };
}
/**
 * The relief as a predicate — what gates behavior besides attachment, and what
 * the UI uses to hide the feature in non-adopting states.
 */
function episodicEventsApplicableForState(state) {
    return (0, jurisdictions_1.jurisdictionRulesFor)(state).adoptsEpisodicEvents;
}
/** The states whose rules leave subpart L unadopted, for queries that filter by state in SQL. */
exports.SUBPART_L_NOT_ADOPTED = states_1.STATES.filter((state) => !episodicEventsApplicableForState(state));
//# sourceMappingURL=relief.js.map